import { IonLoading } from '@ionic/react';
import { ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { logger } from '../../util/logger';
import { useAddDirectConnectCachedMachine } from '../cache/direct-connect-machine-cache';
import { DirectConnectHealthStatus } from '../model/direct-connect.model';

export interface DirectConnectCacheConnectedMachine {
  children: ReactNode;
  healthStatus?: DirectConnectHealthStatus;
}

const DirectConnectCacheConnectedMachine = (
  props: DirectConnectCacheConnectedMachine
) => {
  const { children, healthStatus } = props;

  const { i18n } = useTranslation();
  const { replace } = useHistory();

  const [isSaving, setIsSaving] = useState<boolean>(false);

  const addDirectConnectMachineToCache = useAddDirectConnectCachedMachine();

  useEffect(() => {
    const serialNumber = healthStatus?.serialNumber;
    const machine = healthStatus?.machine;

    if (
      serialNumber &&
      machine?.machineId &&
      machine?.machineName &&
      machine?.teamId
    ) {
      setIsSaving(true);

      addDirectConnectMachineToCache({
        serialNumber,
        id: machine.machineId,
        name: machine.machineName,
        teamId: machine.teamId,
      });

      setIsSaving(false);
    } else {
      logger.error('failed to cache the connected machine', {
        healthStatus,
      });
    }
  }, [replace, addDirectConnectMachineToCache, healthStatus]);

  return (
    <>
      {isSaving && (
        <IonLoading isOpen={isSaving} message={i18n.t('common:saving')} />
      )}
      {children}
    </>
  );
};

export { DirectConnectCacheConnectedMachine };
